import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { getDelegationTokenForOwa, getAccessTokenforResourceAsLazy } from 'owa-tokenprovider';
import { getGuid } from 'owa-guid';
import { trace } from 'owa-trace';
import { IAuthTokenRequest, IAuthTokenResponse } from '@augloop/schemas';

const MSA_TOKEN_SCOPE = 'Compose.Send';
const AUTH_ENDPOINT = 'https://augloop.office.com/v2';
export async function getAuthTokenForAugLoop(): Promise<string | undefined> {
    if (isConsumer()) {
        return getDelegationTokenForOwa(MSA_TOKEN_SCOPE, 'augloop');
    } else {
        let [token, tokenPromise] = getAccessTokenforResourceAsLazy(
            AUTH_ENDPOINT,
            'augloop',
            getGuid()
        );
        if (!token) {
            token = (await tokenPromise) as string;
        }
        return token as string;
    }
}

export async function requestAuthToken(
    tokenRequest: IAuthTokenRequest | undefined
): Promise<IAuthTokenResponse> {
    trace.info('[AugLoopPlugin] requestAuthToken callback');
    return { Token: await getAuthTokenForAugLoop() };
}
